import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-truck-performance-metrics',
	templateUrl: './truck-performance-metrics.component.html',
	styleUrls: ['./truck-performance-metrics.component.css']
})
export class TruckPerformanceMetricsComponent implements OnChanges{
	@Input() data!: any;
	@Input() period!: string;
	@Input() selectedDays!: string;
	@Input() device!: any;

	application_type = {
		GOLF_CART: 2,
		BOAT: 3
	}
	showData: boolean = true;

	PERFORMANCE_LABELS = ['0%-25%', '26%-50%', '51%-75%', '76-100%+'];
	VOLTAGE_LABELS = ['low', 'mid', 'high'];

	truckAhPercentages: any[] = [];
	endVoltagePercentages: any[] = [];
	travelLiftPercentages: any[] = [];

	ngOnChanges(changes: SimpleChanges) {
		if(changes['data'] || changes['period'] || changes['selectedDays']) {
			this.calculateAll();
		}
	}

	calculateAll() {
		this.showData = true;

		this.calculateAhPerformance();
		this.calculateEndVoltagePerformance();
		this.calculateTravelLiftTime();

		const hasData =
			this.truckAhPercentages.length > 0 ||
			this.endVoltagePercentages.length > 0 ||
			this.travelLiftPercentages.length > 0;

		this.showData = hasData;
	}

	calculateAhPerformance() {
		const selectedData = this.data?.[this.period]?.[this.selectedDays]?.truckAhInUse;
		if (!selectedData || selectedData.length === 0) {
			this.truckAhPercentages = [];
			return;
		}

		this.truckAhPercentages = selectedData.map(device => {
			const buckets: number[] = device.inuse_ah || [0, 0, 0, 0];
			const totalDays = device.total_days_in_period || 1;

			const percentages: any = {};

			buckets.forEach((value, index) => {
				const label = this.PERFORMANCE_LABELS[index];
				percentages[label] = Math.round((value / totalDays) * 100);
			});

			return {
				macAddress: device.macAddress,
				percentages
			};
		});
	}

	calculateEndVoltagePerformance() {
		const selectedData = this.data?.[this.period]?.[this.selectedDays]?.endVoltageGroup;

		if (!selectedData || selectedData.length === 0) {
			this.endVoltagePercentages = [];
			return;
		}

		this.endVoltagePercentages = selectedData.map(device => {
			const buckets: number[] = device.end_voltage || [0, 0, 0];

			const totalCycles = buckets.reduce((sum, v) => sum + v, 0);

			const percentages = {
				high: 0,
				mid: 0,
				low: 0
			};

			if (totalCycles > 0) {
				percentages.low  = Math.round((buckets[0] / totalCycles) * 100);
				percentages.mid  = Math.round((buckets[1] / totalCycles) * 100);
				percentages.high = Math.round((buckets[2] / totalCycles) * 100);
			}

			return {
				macAddress: device.macAddress,
				percentages
			};
		});
	}

	calculateTravelLiftTime() {
		const selectedData = this.data?.[this.period]?.[this.selectedDays]?.travelLiftTime;

		if (!selectedData || selectedData.length === 0) {
			this.travelLiftPercentages = [];
			return;
		}

		this.travelLiftPercentages = selectedData.map(device => {
			const travel = device.travelTime || 0;
			const lift = device.liftTime || 0;

			return {
				macAddress: device.macAddress,
				travel,
				lift
			};
		});
	}

	clampPercent(value: number) {
		return Math.min(value, 100) + '%';
	}
}
